import React, { useEffect, useState } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'

import { useMarket } from '../../../utils/market'
import { useConnection } from '../../../utils/connection'

import envConfig from '../../../utils/envConfig'
import { deepClone } from '../../../utils/clone'



const HealthStatusServiceKafka = ({ data, env }) => {

    const marketLookup = useMarket()
    const connectionLookup = useConnection(env)
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const tab_col = [
        {
            field: "id",
            headerName: "Account ID",
            minWidth: 150,
            suppressSizeToFit: true,
        }
    ]

    const tab_col2 = [
        {
            field: "id",
            headerName: "Connection ID",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "connectionName",
            headerName: "Connection Name",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "status",
            headerName: "Status",
            minWidth: 200,
            cellStyle: function (params) {
                if (params.value !== 'up') {
                    return { color: 'white', backgroundColor: '#B4130B' };
                } else if (params.value === 'DISABLED') {
                    return { color: 'white', backgroundColor: '#A6A6A6' };
                } else {
                    return { color: 'black', backgroundColor: 'white' };
                }
            }
        },
    ]

    const [tab_data, settab_data] = useState([])

    useEffect(() => {
        let tab_data_temp = []
        if (data.accounts && marketLookup) {
            tab_data_temp = Object.keys(data.accounts).sort((a, b) => (data.accounts[a].status === 'up') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data.accounts[rowId])

                if (!row.markets || row.markets.length === 0) {
                    row.markets = [0]
                }

                for (let marketName of row.markets) {
                    marketName = marketName ? marketName.replace("TT_MARKET_ID_", "") : "-"

                    rowData.push({
                        'uniqueId': row.id,
                        'id': row.id,
                        'marketName': marketName,
                        'status': row.status,
                        'detailView': {
                            'head': {
                            },
                            'data': [
                                {
                                    'type': 'account_detail',
                                    'subheader': 'Account',
                                    'content': {
                                        'accountId': row.id,
                                    }
                                },
                                {
                                    'type': 'graph_account',
                                    'subheader': 'Hierachy',
                                    'content': {
                                        'accountId': row.id,
                                    },
                                },
                            ],
                        },
                    })

                }
                return rowData
            }, [])
        }

        settab_data(tab_data_temp)
    }, [data.accounts, marketLookup])

    const [tab_data2, settab_data2] = useState([])

    useEffect(() => {
        let tab_data2_temp = []
        if (data.connections && connectionLookup && Object.keys(connectionLookup).length > 0) {
            tab_data2_temp = Object.keys(data.connections).sort((a, b) => (data.connections[a].status === 'up') ? 1 : -1).reduce((rowData, rowId) => {

                const row = deepClone(data.connections[rowId])
                const connectionName = row.id && connectionLookup[row.id] ? connectionLookup[row.id].name : '-'

                if (connectionLookup[row.id]) {

                    const tabs = [
                        {
                            'type': 'json',
                            'subheader': 'Bookie Connection',
                            'content': connectionLookup[row.id],
                        },
                        {
                            'type': 'session_history',
                            'subheader': 'History',
                            'content': {
                                'sessionId': row.id,
                                'sessionType': "connections",
                                'env': env
                            },
                        },
                    ]

                    rowData.push({
                        'uniqueId': row.id,
                        'id': row.id,
                        'connectionName': connectionName,
                        'status': row.status,
                        'detailView': {
                            'head': {
                            },
                            'data': tabs
                        },
                    })
                }

                return rowData
            }, [])
        }
        settab_data2(tab_data2_temp)
    }, [env, connectionLookup, data.connections, liteMode])


    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            {data.accounts.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold">Accounts</Text>
                    <AgDataTable
                        tab_col={tab_col}
                        tab_data={tab_data}
                        tableName="HealthStatusServiceKafka2"
                        defaultSubTab="Account"
                        countTitle="Accounts"
                        tableHeight={700}
                    />
                </>
            }

            {connectionLookup && tab_data2.length > 0 &&
                <>
                    <Text margin={{ top: "8px", bottom: "8px" }}
                        size="small" color="dark-3" weight="bold">Connections</Text>
                    <AgDataTable
                        tab_col={tab_col2}
                        tab_data={tab_data2}
                        tableName="HealthStatusServiceKafkaConnections2"
                        defaultSubTab="Bookie Connection"
                        countTitle="Bookie Connections"
                        tableHeight={700}
                    />
                </>
            }
        </Box>
    )
}

export default HealthStatusServiceKafka